import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconGlobe = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24'>
      <g>
        <path fill={fill} opacity={0.3} d='M12,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z' />
        <path
          fill={fill}
          d='M21.967,12.811a1.567,1.567,0,0,0-1.455.533c-.486.549-1.153.278-2.234-1.716-1.036-1.909-.087-2.749.291-3.916.323-.955-.546-3.356-1.08-4.068v0l.01.01A9.991,9.991,0,0,1,22,12c0,.27-.01.55-.03.81Z'
        />
        <path
          fill={fill}
          d='M14.32,21.73A9.824,9.824,0,0,1,12,22c-.35,0-.69-.02-1.03-.05a3.338,3.338,0,0,0-.15-2.43c-.74-1.1-2.66-1.12-2.73-2.51a14.113,14.113,0,0,0-.07-2.44c-.19-.8-5.08-1.164-4.83-7.284V7.28A9.991,9.991,0,0,1,12,2a10.412,10.412,0,0,1,2.11.22v0a1.9,1.9,0,0,1-1.346,1.785c-2.828.926-.572,4.612-2.454,5-.625.128-1.692-.922-2.292-.777a.87.87,0,0,0-.43,1.481c.85.881.45,1.221.761,1.932s1.3.794,2.468.661,1.693-.193,2.515.663.656,2.066,1.811,2.2,2.467.65,2.3,1.639c-.233,1.383-2.791,2.112-3.126,4.926'
        />
      </g>
    </svg>
  )
}

export default IconGlobe
